/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.StandingBlocks {
    angular.module("meevo.plugins.standingBlocks", []);
}